import TweenMax from 'gsap';

var _W = $(window);

$(function(){

	var $topScreen = $('.page-error');

	$topScreen.each(function () {
		if (_W.width() > 768) {
			$topScreen.mousemove(function(e) {
				parallaxIt(e, ".page-error__plane-container", -20);
			});
		}

		function parallaxIt(e, target, movement) {
			var $this = $topScreen;
			var relX = e.pageX - $this.offset().left;
			var relY = e.pageY - $this.offset().top;

			TweenMax.to(target, 1, {
				x: (relX - $this.width() / 1.5) / $this.width() * movement,
				y: (relY - $this.height() / 1.5) / $this.height() * movement
			});
		}
	});
});
